import {SET_THEME} from "./ThemeTypes";
import theme from "../../styles/DefaultTheme";

export function themeReducer(state = theme, action) {
    switch (action.type) {
        case SET_THEME :
            return action.data;
        default:
            return state;
    }
}
